import type { useAuth } from "@assetwatch/auth";

export function isInternalEnterpriseUser(
  user: ReturnType<typeof useAuth>["user"] | null | undefined,
) {
  return (
    user?.role === "NikolaTeam" ||
    user?.cognitoGroups.includes("NikolaTeam") === true
  );
}
